import { createPortal } from 'react-dom';
import { m } from 'framer-motion';
import List from '@/components/Icons/List';
import ArrowLineUp from '@/components/Icons/ArrowLineUp';
import Buttons from '@/components/Buttons';
import usePopover from '@/hooks/usePopover';
import trackEvents from '@/helpers/trackEvents';

import s from './SectionNavigationButton.module.scss';
import SectionProgressIcon from '../SectionNavigation/SectionProgressIcon';

type SectionNavigationButtonProps = {
  sections: Array<{
    id: string;
    label: string;
    progress: number | null;
    isLoading: boolean;
    hasError?: boolean
  }>;
  currentSection: string;
  onSelectSection: (sectionId: string) => void;
  completed?: boolean;
};

const SectionNavigationButton: React.FC<SectionNavigationButtonProps> = ({ sections, currentSection, onSelectSection, completed }) => {
  trackEvents.track('Rendered SectionNavigationButton');
  const {
    isOpen,
    setIsOpen,
    menuRef,
    triggerRef,
  } = usePopover('bottom-left');
  const currentSectionData = sections.find(section => section.id === currentSection);
  return (
    <>
      <Buttons ref={triggerRef} isWrapper onClick={() => setIsOpen(!isOpen)} className={s.header}>
        {currentSectionData && (
          <>
            {isOpen ? <ArrowLineUp size={16} /> : <List size={16} />}
            <SectionProgressIcon
              isLoading={currentSectionData.isLoading}
              progress={currentSectionData.progress}
              hasError={false}
            />
            <span>{currentSectionData.label}</span>
          </>
        )}
      </Buttons>
      {isOpen && createPortal(
        <m.div ref={menuRef} className={s.menu}
          initial={{ opacity: 0, y: 8 }}
          animate={{
            opacity: 1,
            y: 4,
          }}
        >
          {sections.map(section => (
            <div key={section.id}>
              <Buttons
                isWrapper
                className={`${section.id === currentSection ? s.active : ''} ${section.hasError ? s.error : ''}`}
                onClick={() => {
                  onSelectSection(section.id);
                  setIsOpen(false);
                }}
              >
                {section.label}
                {!completed && (
                  <SectionProgressIcon
                    isLoading={section.isLoading}
                    progress={section.progress}
                    hasError={!!section.hasError}
                  />
                )}
              </Buttons>
            </div>
          ))}
        </m.div>,
        document.body,
      )}
    </>
  );
};

export default SectionNavigationButton;
